var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box select-default-hub-dialog"},[_c('div',{staticClass:"select-default-hub-dialog__info maps"},[_c('SelectDefaultHub',{on:{"selectDefaultHub:back":_vm.close}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }